export default __webpack_public_path__ + "img/007d1bc87d307bd78fe6c64fcd344e88.svg";